// Framework
import { Col, Row } from 'reactstrap';
import { AppContainer } from 'components/style/Containers.style';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import React from 'react';

const NotFound = (props: {}, { t }) => (
  <React.Fragment>
    <Helmet>
      <title>{t('Novus Health Dashboard')}</title>
    </Helmet>
    <AppContainer>
      <Row>
        <Col xs={10}>
          <h1 className={'my-5'}>
            {t('Welcome to the Novus Health Dashboard!')}
          </h1>
          <p>
            {t(
              'Looks like this is not the page you were looking for. To access your organization’s custom site, please enter the URL provided into the address bar at the top of the browser.'
            )}
          </p>
          <p>
            {t(
              'Still can’t find what you’re looking for? Please contact your admin for information on how to access your custom dashboard.'
            )}
          </p>
        </Col>
      </Row>
    </AppContainer>
  </React.Fragment>
);

NotFound.contextTypes = {
  t: PropTypes.func.isRequired
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/pages/NotFound/NotFoundComponent.js